import axios from '@/libs/api.request'
import Qs from 'qs'
export const getpolyDetail = (params) => { // 聚合详情
    return axios.request({
        url: `/group/${params.id}?uid=${params.uid}`,
        method: 'get',
        // params: params
    })
}
export const getpolyClass = (params) => { // 聚合分类
    return axios.request({
        url: `/group.category.${params.group_id}`,
        method: 'post',
        data: params
    })
}
export const getpolyPdf = (params) => { // 聚合绑定pdf详情
    return axios.request({
        url: `/group.document`,
        method: 'post',
        data: params
    })
}
export const sendEmail = (params) => { // 聚合分享邮件
    return axios.request({
        url: `/group.sendToEmail`,
        method: 'post',
        data: params
    })
}
export const getForm = (params) => { // 获取表单
    return axios.request({
        url: `/form/${params.id}`,
        method: 'get',
    })
}
export const statData = (params) => { // 统计查看人数次数
    return axios.request({
        url: `/action/create`,
        method: 'post',
        data: params
    })
}
export const setdownShare = (params) => { // 统计查看人数次数
    return axios.request({
        url: `/collect/create`,
        method: 'post',
        data: params
    })
}
export const groupCreateForm = (params) => { // 聚合表单提交
    return axios.request({
        url: 'group_user/create',
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            // 请求数据前，对数据处理
            for (var key in data) {
                if (!data[key]) {
                    // console.log('1ed3w',data[key]);
                    if (data[key] != 0) {
                        delete data[key]
                    }
                    
                }
            }
            // console.log('请求的参数', data)
            data = Qs.stringify(data)
            return data
        }]
    })
}
